import { LayoutComponentProps } from 'scbk-services';

interface EmptyLayoutProps extends LayoutComponentProps {}

const EmptyLayout = ({ children }: EmptyLayoutProps) => {
  return <>{children}</>;
};

export { EmptyLayout };
